import Vue from 'vue'
import Axios from 'axios'

import Battle from '../Battle.vue'

Vue.prototype.$http = Axios

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import 'bulma/css/bulma.min.css'

Vue.use(Buefy)

new Vue({
  render: h => h(Battle)
}).$mount('#app')
